module.exports = __webpack_public_path__ + "img/btn-arrow-left.3e485450.svg";